import React, { useState } from 'react';
import styles from '../styles/CompareSnakes.module.css';
import ComparePlayerSnakes from '../components/ComparePlayerSnakes';
import CompareTeamSnakes from '../components/CompareTeamSnakes';
import SeasonDropdown from '../components/SeasonDropdown';

export default function CompareSnakesPage() {
  // "compareType" can be "players", "goalies", or "teams"
  const [compareType, setCompareType] = useState('players');
  const [selectedSeason, setSelectedSeason] = useState('20242025');

  return (
    <div className={styles.pageContainer}>
      <h1 className={styles.pageTitle}>
        Compare {compareType === 'teams' ? 'Team' : (compareType === 'goalies' ? 'Goalie' : 'Player')} Stats
      </h1>

      {/* Season Dropdown at the top */}
      <SeasonDropdown selectedSeason={selectedSeason} onSeasonChange={setSelectedSeason} />

      {/* Top-level Toggle */}
        <div className={styles.compareToggle}>
            <input
                type="radio"
                id="comparePlayers"
                name="compareType"
                value="players"
                checked={compareType === 'players'}
                onChange={() => setCompareType('players')}
            />
            <label htmlFor="comparePlayers">Players</label>

            <input
                type="radio"
                id="compareGoalies"
                name="compareType"
                value="goalies"
                checked={compareType === 'goalies'}
                onChange={() => setCompareType('goalies')}
            />
            <label htmlFor="compareGoalies">Goalies</label>

            <input
                type="radio"
                id="compareTeams"
                name="compareType"
                value="teams"
                checked={compareType === 'teams'}
                onChange={() => setCompareType('teams')}
            />
            <label htmlFor="compareTeams">Teams</label>
        </div>

        {/* Conditional rendering based on compareType */}
        {compareType === 'teams' ? (
            <CompareTeamSnakes season={selectedSeason}/>
        ) : (
            <ComparePlayerSnakes compareType={compareType} season={selectedSeason}/>
        )}
    </div>
  );
}
